module.exports = __webpack_public_path__ + "img/live-in-play-star.a7e5b1a0.svg";